// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Pervasives from "../../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ViewUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ViewUtils.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function getVehicleInfoDisplayRecord(vehicleInfo) {
  return {
          hd: {
            label: "Vehicle Type",
            value: {
              TAG: /* Text */0,
              _0: vehicleInfo.vehicleType
            }
          },
          tl: {
            hd: {
              label: "Vehicle Number",
              value: {
                TAG: /* Text */0,
                _0: vehicleInfo.vehicleNumber
              }
            },
            tl: {
              hd: {
                label: "Serviceable Vehicle Types",
                value: {
                  TAG: /* Text */0,
                  _0: ViewUtils$Catalyst.createViewFromList(vehicleInfo.serviceVehicleTypes, ",")
                }
              },
              tl: {
                hd: {
                  label: "Vehicle NEP Status",
                  value: {
                    TAG: /* Text */0,
                    _0: Belt_Option.mapWithDefault(vehicleInfo.hasNep, "NA", Pervasives.string_of_bool)
                  }
                },
                tl: {
                  hd: {
                    label: "Fuel Category",
                    value: {
                      TAG: /* Text */0,
                      _0: vehicleInfo.fuel_category
                    }
                  },
                  tl: /* [] */0
                }
              }
            }
          }
        };
}

function getView(driverInfo) {
  return React.createElement(CardComponent$Catalyst.make, {
              title: "Vehicle Info",
              className: "vehicle-info-container",
              children: React.createElement(FetchLoadableViewMapper$Catalyst.make, {
                    loadableData: driverInfo,
                    children: (function (driverInfo) {
                        return CardRowViewMapper$Catalyst.CardRecordView.make("record", getVehicleInfoDisplayRecord(driverInfo.vehicle));
                      })
                  })
            });
}

export {
  getVehicleInfoDisplayRecord ,
  getView ,
  
}
/* react Not a pure module */
